import * as yup from 'yup';

const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;

export const storeSchema = yup.object().shape({
  jazzStoreId: yup.string().required('JazzStoreID é obrigatório'),
  cnpj: yup.string().matches(cnpjRegex, 'CNPJ inválido').required('CNPJ é obrigatório'),
  email: yup.string().email('Informe um e-mail válido').required('E-mail é obrigatório'),
  password: yup.string().min(6, 'A senha deve ter no mínimo 6 caracteres').required('Senha é obrigatória'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'As senhas devem ser iguais')
    .required('Confirmação de senha é obrigatória'),
  isMotorola: yup.boolean().required('Selecione se é uma loja Motorola'),
  storeGroupId: yup.string().required('Grupo é obrigatório'),
});
